import { useCustomer } from 'components/Customer'
import CustomerSelect from 'components/CustomerSelect'
import { useDialog } from 'components/Dialog'
import { useOrderNews } from 'components/OrderNews'
import ThemeContext from 'components/ThemeContext'
import TopbarComponent from 'components/Topbar'
import SettingsDialog from 'containers/SettingsDialog'
import TenantSwitcher from 'containers/TenantSwitcher'
import lodash from 'lodash'
import React, { useContext } from 'react'

import PrinterSelect from './PrinterSelect'

const Topbar = (props) => {
  const { applyFilterOrders, applyFilterAddressBook } = props

  const settingsDialog = useDialog()

  const theme = useContext(ThemeContext)

  const { currentCustomer, presets } = useCustomer()

  const { open: openOrderNews, isVisible: isOrderNewsVisible } = useOrderNews()

  const fixedPresets = []
  fixedPresets.push({ ...lodash.first(presets), id: undefined })
  presets.slice(1).forEach((preset) => fixedPresets.push(preset))

  const tenant = global.tenantSettings

  let logo =
    lodash.get(currentCustomer, 'logoUrl') || lodash.get(tenant, 'returnlogo')

  const title = lodash.get(currentCustomer, 'postaladdress.name1') // lodash.get(global.tenantSettings, "returntitle", {i18n.t("returns", "Retouren")

  const items = [
    ...fixedPresets.map(({ id, name }) => ({
      to: id ? `/quickorder/${id}` : '/',
      label: name,
      icon: 'fas fa-file',
    })),
    {
      to: '/orders',
      icon: 'fas fa-folder',
      label: i18n.t('label_ordermanagement', 'Auftragsverwaltung'),
      children: [
        {
          href: '/orders',
          target: '_blank',
          icon: 'fas fa-list',
          label: i18n.t('label_order_list', 'Aufträge'),
        },
        {
          to: '/templates',
          icon: 'fas fa-list',
          label: i18n.t('label_order_presets', 'Vorlagen'),
        },
      ],
    },
    {
      to: '/handovers',
      icon: 'fas fa-exchange-alt',
      label: i18n.t('handOverLists', 'Übergabelisten'),
    },
    {
      to: '/addressbook',
      icon: 'fas fa-users',
      label: i18n.t('addressbook', 'Adressbuch'),
    },
    lodash.get(currentCustomer, 'cronOrdersEnabled', false)
      ? {
          to: '/cronorders',
          icon: 'fas fa-clock',
          label: i18n.t('cron_orders', 'Daueraufträge'),
        }
      : null,
    lodash.get(currentCustomer, 'hasCustoms') && {
      to: '/customs',
      icon: 'fas fa-file-invoice-dollar',
      label: i18n.t('label_customs', 'Zolldaten'),
    },
    {
      href: global.tenantSettings.trackingUrl,
      target: '_blank',
      icon: 'fas fa-broadcast-tower',
      label: i18n.t('label_tnt', 'Track & Trace'),
    },
  ].filter(Boolean)

  if (!global.currentUser.roles.includes('customer')) {
    items.push({
      to: '/interfaces',
      icon: 'fas fa-cogs',
      label: i18n.t('label_interfaces', 'Anbindungen'),
    })
  }

  if (lodash.get(currentCustomer, 'massOrderUploadEnabled')) {
    items.push({
      to: '/order-jobs',
      icon: 'fas fa-upload',
      label: i18n.t('order_import_tab', 'Auftragsupload'),
    })
  }

  const centerItems = [
    <CustomerSelect key="customerSelect" />,
    <PrinterSelect key="printerSelect" />,
    <div className="ml-2" key="tenantSwitcher">
      <TenantSwitcher
        tenants={lodash.get(global.currentUser, 'switchableTenants')}
      />
    </div>,
  ].filter(Boolean)

  const rightItems = [
    isOrderNewsVisible
      ? {
          icon: 'far fa-comment-alt-exclamation',
          tooltip: i18n.t('important_information', 'Wichtige Informationen'),
          onClick: openOrderNews,
        }
      : undefined,
    {
      icon: 'far fa-user',
      tooltip: i18n.t('tooltip_toManage', 'Zum Manage'),
      href: /(localhost|staging)/.test(window.location)
        ? 'https://manage.staging.1st-scan.net'
        : 'https://manage.1st-scan.net',
    },
    {
      icon: 'far fa-cog',
      tooltip: i18n.t('tooltip_settings', 'Einstellungen'),
      onClick: settingsDialog.open,
    },
    {
      icon: 'far fa-power-off',
      tooltip: i18n.t('tooltip_logout', 'Abmelden'),
      href: '/logout',
      hrefTarget: '_self',
    },
  ].filter(Boolean)

  return (
    <React.Fragment>
      <TopbarComponent
        key={i18n.language}
        theme={theme}
        logo={logo}
        items={items}
        centerItems={centerItems}
        rightItems={rightItems}
        text={title}
        centered
        subtext={i18n.t('subtext_order', 'Auftragserfassung')}
        isStaging={/(localhost|staging)/.test(window.location)}
        fluidNav={true}
        fluidHeader={true}
        showLanguageSelect
      />
      <SettingsDialog {...settingsDialog} />
    </React.Fragment>
  )
}

export default Topbar
